import { Venue } from "./venue";

export class City {
  public id?: string;
  public city_name: string;
  public coordinates: firebase.firestore.GeoPoint;
  public image: string;
  public is_active: boolean;
  public state: string;
  public timezone: string;
  public venues: Venue[];
  public active_venues: number;
}
